import { Box, Button, Typography, alpha, useTheme } from '@mui/material';
import { useAppSelector } from '../../hooks/useAppStore';

/**
 * Barra persistente en el CRM cuando la sesión es la cuenta demo (`isDemo`).
 * Avisa que es una demo (datos se reinician a diario) e invita a contratar.
 */
export function DemoBanner() {
  const isDemo = useAppSelector((s) => s.auth.user?.isDemo);
  /**
   * El verde estaba escrito a mano (#34d399 / #059669) y sobrevivió al cambio de marca:
   * la barra quedaba verde arriba de un CRM cian, y en Imperium arriba de uno dorado.
   * Ahora sale del tema, así que acompaña a la marca activa —o al color del tenant en un
   * white-label— sin tocar nada acá. (20/08/2026)
   */
  const t = useTheme();
  const ACENTO = t.palette.primary.main;
  const ACENTO_CLARO = t.palette.primary.light;
  if (!isDemo) return null;

  return (
    <Box
      sx={{
        display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap',
        px: { xs: 2, md: 2.5 }, py: 1, mx: { xs: 2, sm: 3, md: 4 }, mt: 2, borderRadius: 2,
        bgcolor: alpha(ACENTO, 0.12), border: `1px solid ${alpha(ACENTO_CLARO, 0.35)}`,
      }}
    >
      <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: ACENTO_CLARO,
        boxShadow: `0 0 8px ${ACENTO_CLARO}`, flexShrink: 0 }} />
      <Typography sx={{ fontSize: 13.5, color: 'text.primary', flex: 1, minWidth: 200 }}>
        Estás en una <strong>demo de Booster</strong> — explorá libremente. Los datos se reinician a diario.
      </Typography>
      <Button
        href="/#precios" size="small" variant="contained"
        sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 999, px: 2,
          bgcolor: ACENTO, color: t.palette.primary.contrastText,
          '&:hover': { bgcolor: ACENTO_CLARO },
          boxShadow: `0 4px 14px ${alpha(ACENTO, 0.35)}` }}
      >
        Quiero mi cuenta
      </Button>
    </Box>
  );
}
